import router from '@/router';

const pubRoutes = [
  {
    path: '/planning',
    name: 'DeviceDayPlanning',
    component: () => import('../views/DeviceDayPlanning.vue'),
    meta: { publicRoute: true, layout: 'Device' },
  },
];

pubRoutes.forEach(route => router.addRoute(route));